import React from "react";
import pic from "../../assets/img/YP-logo.png";

function ErrorPage() {
  return (
    <div
      className=" d-flex justify-content-center "
      style={{ height: "100vh" }}
    >
      <div
        className="d-flex justify-content-start flex-column align-items-start align-self-center  pt-4 "
        style={{ height: "50vh" }}
      >
        <img src={pic} width="180px" className="my-2" alt="." />
        <p className="my-3">
          <b>403.</b> Access forbidden
        </p>
        <p className="my-2" style={{ fontSize: "16px" }}>
          It is not possible to provide services to these countries : Iran -
          United States of America - Israel - Pakistan
        </p>
      </div>
    </div>
  );
}

export default ErrorPage;
